export const TEACHER = 'TEACHER'
export const STUDENT = 'STUDENT'

export const USER_MEDIA_ERROR = {
    NOT_ALLOWED: 'NotAllowedError',
    NOT_FOUND_ERROR: 'NotFoundError',
    NOT_READABLE_ERROR: 'NotReadableError',
    TRACK_START_ERROR: 'TrackStartError',
}

export const feedbackGifs = [
    {
        id: 1,
        gif:
            'https://i.pinimg.com/originals/28/7b/61/287b612d87648274e86c7e12124a2e66.gif',
    },
    {
        id: 2,
        gif: 'https://media.giphy.com/media/8Ry7iAVwKBQpG/giphy.gif',
    },
    {
        id: 3,
        gif: 'https://media.giphy.com/media/KI9oNS4JBemyI/giphy.gif',
    },
    {
        id: 4,
        gif: 'https://visme.co/blog/wp-content/uploads/2020/02/header-1200.gif',
    },
    {
        id: 5,
        gif: 'https://visme.co/blog/wp-content/uploads/2020/02/header-1200.gif',
    },
    {
        id: 6,
        gif:
            'https://visme.co/blog/wp-content/uploads/2019/09/interactive-presentation-header.gif',
    },
    {
        id: 7,
        gif: 'https://media2.giphy.com/media/dJezVlwfVulTykjRQj/source.gif',
    },
    {
        id: 8,
        gif:
            'https://cdn.dribbble.com/users/185738/screenshots/2751203/cowboy.gif',
    },
]

export const JEOPARDY_URLS = {
    TEACHER_URL: 'https://www.playfactile.com/historyforoh/play',
    STUDENT_URL: 'https://www.playfactile.com/join',
}
